<script>
import QtyInputField from "../product-item/QtyInputField.svelte";
import BtnShowMore from "./BtnShowMore.svelte";
export let item;
</script>

<div
  class="product-list-item"
  data-article-number="123"
  data-name="productname"
  data-brand="brandname"
  data-category="top level category"
  data-price="123,78"
>
  <div class="gr-header">
    <h4>
      <a href="IboxServlet?p=IXS480&amp;OPT=GET&AID=152090">{item.title}</a>
    </h4>
    <p>Artikel: {item.info.article}</p>
  </div>
  <div class="gr-labels">
    <span class="fcond article-in-stock label label-default">I lager: 8</span>
    <span class="fcond article-in-stock label label-danger">Utgående</span>
  </div>
  <div class="gr-price">
    <div>
      <p class="new-item-links">
        <a href="#">Bli företagskund</a>
        eller
        <a href="#">logga</a>
        in för att se priser och beställa.
      </p>
    </div>
    <div class="fcond fdark">
      <h3>1878,00 <span>SEK</span></h3>
      <h5>Listpris: <span>3130,00</span> SEK</h5>
    </div>

    <div class="add-to-cart">
      <form
        class="form-inline"
        id="product-order-152090"
        data-aid="152090"
        method="post"
      >
        <div class="input-group">
          <QtyInputField />
          <button
            type="submit"
            class="button btn btn-success btn-cart"
            data-event="addToCart"
          ><span><svg
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 1a1 1 0 011-1h2.838l.405 1h11.139C16.869 1 17.665 2.676 17 4.006l-1.83 3.888A2 2 0 0113.383 9H6.535l-.67 1.006c2.733.008 7.573.017 8.613-.006a1 1 0 01.044 2c-1.072.024-5.955.014-8.667.006C4.256 12 3.318 10.22 4.2 8.897l.667-1.001L2.5 2.006 1 2a1 1 0 01-1-1zm6.66 6h6.074a1 1 0 00.913-.592L15.17 3M6.659 7L5.068 3h10.103"
                ></path>
                <circle cx="6" cy="14.506" r="1.5"></circle>
                <circle cx="13.5" cy="14.506" r="1.5"></circle>
              </svg><span>&nbsp;Köp</span></span></button>
        </div>
      </form>
    </div>

    <div>
      <a
        class="btn btn-light"
        href="#"
        id="save-shoppinglist"
        data-aid="152090"
      >
        <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.818213 4.90909H4.90912V0.818182C4.90912 0.366544 5.27567 0 5.7273 0H6.27273C6.72436 0 7.09091 0.366544 7.09091 0.818182V4.90909H11.1818C11.6335 4.90909 12 5.27564 12 5.72727V6.2727C12 6.72433 11.6335 7.09088 11.1818 7.09088H7.09091V11.1818C7.09091 11.6334 6.72436 12 6.27273 12H5.7273C5.27567 12 4.90912 11.6334 4.90912 11.1818V7.09088H0.818213C0.366574 7.09088 3.05176e-05 6.72433 3.05176e-05 6.2727V5.72727C3.05176e-05 5.27564 0.366574 4.90909 0.818213 4.90909Z"
            fill="#2751BC"
          ></path>
        </svg>

        Köplistor
      </a>
      <a class="btn btn-light" href="#" id="save-favourite" data-aid="152090">
        <svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.34731 0.684034C6.57832 0.0879918 7.42168 0.0879903 7.65269 0.684032L8.85886 3.79611C8.95818 4.05236 9.19826 4.22679 9.47266 4.24206L12.8051 4.42751C13.4434 4.46303 13.704 5.26511 13.2085 5.66901L10.6215 7.77783C10.4085 7.95147 10.3168 8.2337 10.387 8.49939L11.2405 11.7261C11.4039 12.3441 10.7216 12.8398 10.1844 12.4934L7.37935 10.6846C7.14838 10.5357 6.85162 10.5357 6.62065 10.6846L3.81561 12.4934C3.27837 12.8398 2.59608 12.3441 2.75953 11.7261L3.61295 8.49939C3.68322 8.2337 3.59152 7.95147 3.3785 7.77783L0.791466 5.66901C0.295983 5.26511 0.556594 4.46303 1.19485 4.42751L4.52734 4.24206C4.80174 4.22679 5.04182 4.05236 5.14114 3.79611L6.34731 0.684034Z"
            fill="#2751BC"
          ></path>
        </svg>
        Spara favorit
      </a>
    </div>
    <div class="gr-extra">
      <div class="gr-extra-1">
        <p>Varumärke:</p>
        <p>Step</p>
      </div>
      <div class="gr-extra-1">
        <p>Varumärkes-ID:</p>
        <p>37010101</p>
      </div>
    </div>
  </div>
  <div class="gr-pic">
    <img
      class="img-responsive product-search-result-image"
      src="{item.picture}"
      onerror="this.src = 'assets/image-placeholder.svg'"
      alt="item ES19 12/24V Rättvänd"
    />
  </div>
  <div class="gr-info">
    <div class="gr-info-1">
      <p>VARUMÄRKES-ID:</p>
      <p>37010101</p>
    </div>
    <div class="gr-info-1">
      <p>ARMSYSTEM:</p>
      <p>Glidskena</p>
    </div>
    <div class="gr-info-1">
      <p>DÖRRBLADSBREDD MAX:</p>
      <p>1100 mm</p>
    </div>
    <div class="gr-info-1">
      <p>ELMEKANISK UPPSTÄLLNING:</p>
      <p>Nej</p>
    </div>
    <div class="gr-info-1">
      <p>ENKEL DÖRR/PARDÖRR:</p>
      <p>Enkel dörr</p>
    </div>
    <div class="gr-info-1">
      <p>MONTAGESÄTT DÖRRSTÄNGARHUS:</p>
      <p>Dörr Gångjärnssida</p>
    </div>
  </div>
  <div class="bg-fade hidden">
    <BtnShowMore />
  </div>
</div>
